export const translations = {
  en: {
    // Navbar
    nav: {
      about: "About",
      projects: "Projects",
      contact: "Contact",
      letsTalk: "Let's Talk",
    },
    // Hero
    hero: {
      subtitle: "Web Developer & Designer",
      title1: "Creating digital",
      title2: "experiences",
      description:
        "I craft minimal, elegant websites that tell your story and elevate your brand through thoughtful design and clean code.",
      scroll: "Scroll",
      sideText: "Portfolio " + new Date().getFullYear(),
    },
    // About
    about: {
      sectionTitle: "About",
      heading1: "Designing with",
      heading2: "purpose & precision",
      bio1: "I'm isifu, a web developer and designer based in Poland, specializing in creating minimal, elegant digital experiences that resonate with audiences and drive results.",
      bio2: "With years of experience, I've worked with startups, agencies, and established brands to bring their visions to life through thoughtful design and clean code.",
      bio3: "My approach combines strategic thinking with aesthetic sensibility, ensuring every project is both beautiful and functional.",
      expertise: "Expertise",
      skills: [
        "UI/UX Design",
        "React.js",
        "Tailwind CSS",
        "PHP",
        "HTML",
        "CSS",
        "JavaScript",
        "Wordpress",
      ],
      stats: {
        years: "Years Experience",
        projects: "Projects Completed",
        clients: "Happy Clients",
      },
      quote:
        '"Design is not just what it looks like and feels like. Design is how it works."',
      quoteAuthor: "— Steve Jobs",
    },
    // Projects
    projects: {
      sectionTitle: "Selected Work",
      projectsCount: "Projects",
      viewProject: "View Project",
      items: [
        {
          title: "Beyond Space",
          category: "Web Development",
          year: "2026",
          description: "Complete foundation website with CMS",
          image:
            "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80",
          link: "https://beyondspace.org.pl",
        },
        {
          title: "AS-COM",
          category: "Web Development",
          year: "2024",
          description: "Clean, typography-focused portfolio website",
          image:
            "https://images.unsplash.com/photo-1555421689-d68471e189f2?auto=format&fit=crop&w=800&q=80",
          link: "https://new.ascom.klodzko.pl",
        },
      ],
    },
    // Contact
    contact: {
      sectionTitle: "Get in Touch",
      heading1: "Let's create",
      heading2: "something together",
      description:
        "Have a project in mind? I'd love to hear about it. Send me a message and let's discuss how we can bring your vision to life.",
      email: "Email",
      location: "Location",
      locationValue: "Poland",
      followMe: "Follow Me",
      form: {
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "your@email.com",
        message: "Message",
        messagePlaceholder: "Tell me about your project...",
        submit: "Send Message",
        sending: "Sending...",
      },
      toast: {
        success: "Message sent successfully!",
        successDesc: "I'll get back to you soon.",
        error: "Failed to send message",
        errorDesc: "Please try again later or contact me directly via email.",
      },
    },
    // Footer
    footer: {
      rights: "All rights reserved.",
      backToTop: "Back to top ↑",
    },
  },
  pl: {
    // Navbar
    nav: {
      about: "O mnie",
      projects: "Projekty",
      contact: "Kontakt",
      letsTalk: "Porozmawiajmy",
    },
    // Hero
    hero: {
      subtitle: "Web Developer & Designer",
      title1: "Tworzę cyfrowe",
      title2: "doświadczenia",
      description:
        "Tworzę minimalistyczne, eleganckie strony internetowe, które opowiadają Twoją historię i wzmacniają Twoją markę poprzez przemyślany design i czysty kod.",
      scroll: "Przewiń",
      sideText: "Portfolio " + new Date().getFullYear(),
    },
    // About
    about: {
      sectionTitle: "O mnie",
      heading1: "Projektuję z",
      heading2: "celem i precyzją",
      bio1: "Jestem isifu, web developer i designer z Polski, specjalizuję się w tworzeniu minimalistycznych, eleganckich cyfrowych doświadczeń, które rezonują z odbiorcami i przynoszą rezultaty.",
      bio2: "Dzięki wieloletniemu doświadczeniu współpracowałem ze startupami, agencjami i uznanymi markami, pomagając im realizować ich wizje poprzez przemyślany design i czysty kod.",
      bio3: "Moje podejście łączy strategiczne myślenie z wrażliwością estetyczną, zapewniając, że każdy projekt jest zarówno piękny, jak i funkcjonalny.",
      expertise: "Specjalizacje",
      skills: [
        "UI/UX Design",
        "React.js",
        "Tailwind CSS",
        "PHP",
        "HTML",
        "CSS",
        "JavaScript",
        "Wordpress",
      ],
      stats: {
        years: "Lat doświadczenia",
        projects: "Ukończonych projektów",
        clients: "Zadowolonych klientów",
      },
      quote:
        '"Design to nie tylko jak coś wygląda. Design to sposób, w jaki to działa."',
      quoteAuthor: "— Steve Jobs",
    },
    // Projects
    projects: {
      sectionTitle: "Wybrane prace",
      projectsCount: "Projekty",
      viewProject: "Zobacz projekt",
      items: [
        {
          title: "Beyond Space",
          category: "Web Design",
          year: "2026",
          description: "Strona wizytówkowa dla fundacji wraz z systemem zarządzania treścią",
          image:
            "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80",
          link: "https://beyondspace.org.pl",
        },
        {
          title: "AS-COM",
          category: "Web Development",
          year: "2025",
          description: "Strona wizytówkowa dla firmy AS-COM",
          image:
            "https://images.unsplash.com/photo-1555421689-d68471e189f2?auto=format&fit=crop&w=800&q=80",
          link: "https://new.ascom.klodzko.pl",
        },
      ],
    },
    // Contact
    contact: {
      sectionTitle: "Kontakt",
      heading1: "Stwórzmy",
      heading2: "coś razem",
      description:
        "Masz projekt w głowie? Chętnie o nim usłyszę. Napisz do mnie, a porozmawiamy, jak możemy zrealizować Twoją wizję.",
      email: "Email",
      location: "Lokalizacja",
      locationValue: "Polska",
      followMe: "Obserwuj mnie",
      form: {
        name: "Imię",
        namePlaceholder: "Twoje imię",
        email: "Email",
        emailPlaceholder: "twoj@email.com",
        message: "Wiadomość",
        messagePlaceholder: "Opowiedz mi o swoim projekcie...",
        submit: "Wyślij wiadomość",
        sending: "Wysyłanie...",
      },
      toast: {
        success: "Wiadomość wysłana!",
        successDesc: "Wkrótce się odezwę.",
        error: "Nie udało się wysłać wiadomości",
        errorDesc: "Spróbuj ponownie później lub skontaktuj się bezpośrednio przez e-mail.",
      },
    },
    // Footer
    footer: {
      rights: "Wszelkie prawa zastrzeżone.",
      backToTop: "Wróć na górę ↑",
    },
  },
};
